import { LuUser2 } from "react-icons/lu";
import { MdOutlinePassword } from "react-icons/md";
import { IoEyeOutline } from "react-icons/io5";
import { IoEyeOffOutline } from "react-icons/io5";
import { PiSquareLight } from "react-icons/pi";
import { MdCheckBox } from "react-icons/md";
import { PiBuildingOffice } from "react-icons/pi";
import { IoMailOutline } from "react-icons/io5";
import { AiOutlinePieChart } from "react-icons/ai";
import { AiTwotoneQuestionCircle } from "react-icons/ai";
import { TbMenu2 } from "react-icons/tb";
import { GrClose } from "react-icons/gr";
import { IoListOutline } from "react-icons/io5";
import { AiOutlineLogout } from "react-icons/ai";
import { RiAddLargeFill } from "react-icons/ri";
import { IoArrowBack } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import { FaRegCircle } from "react-icons/fa6";
import { FaRegCircleDot } from "react-icons/fa6";
import { AiOutlineUserAdd } from "react-icons/ai";
import { TbProgress } from "react-icons/tb";
import { MdOutlineSignalCellularAlt } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import { SlOptions } from "react-icons/sl";
import { FaChevronDown } from "react-icons/fa6";
import { SlMagnifier } from "react-icons/sl";
import { FaChevronUp } from "react-icons/fa";
import { AiOutlineEdit } from "react-icons/ai";
import { AiOutlineFileExcel } from "react-icons/ai";
import { CiCircleMinus } from "react-icons/ci";
import { GoArrowRight } from "react-icons/go";
import { GoArrowLeft } from "react-icons/go";

export const userIcon = <LuUser2 className="icon" />
export const emailIcon = <IoMailOutline className="icon" />
export const passwordIcon = <MdOutlinePassword className="icon" />
export const visibleIcon = <IoEyeOutline className="icon" />
export const invisibleIcon = <IoEyeOffOutline className="icon" />
export const checkboxEmptyIcon = <PiSquareLight className="icon" />
export const checkboxCheckedIcon = <MdCheckBox className="icon" />
export const buildingIcon = <PiBuildingOffice className="icon"/>
export const piechartIcon = <AiOutlinePieChart className="icon" />
export const questionMarkIcon = <AiTwotoneQuestionCircle className="icon" />
export const hamburgerMenuIcon = <TbMenu2 className="icon" />
export const closeIcon = <GrClose className="icon" />
export const listIcon = <IoListOutline className="icon" />
export const logoutIcon = <AiOutlineLogout className="icon" />
export const addIcon = <RiAddLargeFill className="icon"/>
export const goBackIcon = <IoArrowBack className="icon" />
export const deletIcon = <MdDelete className="icon" />
export const circleIcon = <FaRegCircle className="icon" />
export const circleDotIcon = <FaRegCircleDot className="icon" />
export const userAddIcon = <AiOutlineUserAdd  className="icon"/>
export const progressIcon = <TbProgress className="icon" />
export const signalIcon = <MdOutlineSignalCellularAlt className="icon" />
export const rightIcon = <FaArrowRight className="icon" />
export const optionIcon = <SlOptions className="icon" />
export const downIcon = <FaChevronDown className="icon" />
export const upIcon = <FaChevronUp className="icnon" />
export const magnifierIcon = <SlMagnifier className="icon" />
export const editIcon = <AiOutlineEdit className="icon"/>
export const excelFileIcon = <AiOutlineFileExcel className="icon" />
export const circleMinusIcon = <CiCircleMinus className="icon" />
export const rightArrowIcon = <GoArrowRight className="icon" />
export const leftArrowIcon = <GoArrowLeft className="icon" />